import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    roleBox: {
        margin: '3px 0',
        border: '1px solid #EFEFEF',
        padding: '1rem',
    },
    userInfoContainer: {
        margin: '-20px 0',
    },
    roleRadio: {
        marginRight: '15px',
    },
    roleSubtitle: {
        marginBottom: '0.5rem',
    },
    errorAlert: {
        marginBottom: '1rem',
    },
}));
